import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

export default function HouseholdRegistration() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [statusText, setStatusText] = useState('');

  useEffect(() => {
    Promise.all([
      api.get('/party-amnesty/status'),
      api.get('/hukou/status'),
    ]).then(([partyRes, hukouRes]) => {
      if (!partyRes.data.has_applied) {
        navigate('/party-amnesty', { replace: true });
        return;
      }
      if (hukouRes.data.has_registered) {
        navigate('/new-id-card', { replace: true });
      }
    }).catch(() => { });
  }, []);

  async function handleSubmit() {
    if (hasApplied || submitting) return;
    setSubmitting(true);
    try {
      const { data: me } = await api.get('/me');
      const userName = me.kyc?.name || '';
      const userIdCard = me.kyc?.id_number || '';
      if (!userName || !userIdCard) {
        toast.error('请先完成实名认证');
        setSubmitting(false);
        return;
      }
      await api.post('/hukou', {
        name: userName,
        id_card_number: userIdCard,
      });
      toast.success('申请提交成功');
      navigate('/new-id-card', { replace: true });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || '提交失败');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto min-h-screen">
      <AuthGuard />

      {/* Hero */}
      <div className="relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/90 text-black/80"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
      </div>

      <div className="relative">
        {/* Household register book image */}
        <img src="/images/louhu.png" alt="户口簿" className="w-full" />
        {/* Submit / Status */}
        <div className="absolute bottom-[40px] w-full max-w-md mx-auto ">
          {hasApplied ? (
            <div className="text-center py-3">
              <div className="inline-block bg-[#fef2f2] text-[#c4161c] font-bold text-sm px-6 py-3 rounded-full">
                已申请（{statusText}）
              </div>
            </div>
          ) : (
            <button
              onClick={handleSubmit}
              disabled={submitting}
              className="w-full">
              <img src={"/images/louhu_button.png"} alt="louhu_button" className="w-[330px] mx-auto" />
            </button>
          )}
        </div>

      </div>
    </div >
  );
}
